/**
 * Buscador de tablas del portal.
 *
 * Es el campo de búsqueda que va encima de los listados, con su lupa y el botón
 * para limpiar. Mantiene el mismo aspecto en todas las pantallas (antes sólo lo
 * tenía Comprobantes) y evita repetir el marcado en cada página.
 *
 *   const [busqueda, setBusqueda] = useState('');
 *   <Buscador valor={busqueda} onChange={setBusqueda} ariaLabel="Buscar consumos" />
 */

import { Search, X } from 'lucide-react';

import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

interface BuscadorProps {
  valor: string;
  onChange: (valor: string) => void;
  /** Texto de ejemplo; conviene enumerar los campos por los que se busca. */
  placeholder?: string;
  /** Nombre accesible del campo (`aria-label`). */
  ariaLabel: string;
  className?: string;
}

export function Buscador({ valor, onChange, placeholder, ariaLabel, className }: BuscadorProps) {
  return (
    <Input
      type="search"
      value={valor}
      onChange={(evento) => onChange(evento.target.value)}
      placeholder={placeholder ?? 'Buscar…'}
      aria-label={ariaLabel}
      containerClassName={cn('min-w-[220px] flex-1 sm:max-w-sm', className)}
      className="h-10 [&::-webkit-search-cancel-button]:appearance-none"
      leftIcon={<Search className="size-4" aria-hidden="true" />}
      rightSlot={
        valor ? (
          <button
            type="button"
            onClick={() => onChange('')}
            className="mr-1 flex size-7 items-center justify-center rounded-full text-ink-400 transition-colors hover:bg-ink-100 hover:text-ink-700"
            aria-label="Limpiar búsqueda"
          >
            <X className="size-4" aria-hidden="true" />
          </button>
        ) : undefined
      }
    />
  );
}
